<template>
  <div class="supplier">
    <v-card class="mt-4" :loading="loading">
      <v-card-title>
        <h1 class="mr-2 subheading grey--text">Αγορές</h1>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text ma=4>
        <v-row class="ma-4">
        <v-select
          v-model="year"
          :items="years"
          label="Έτος"
          single-line
          hide-details
          style="max-width: 120px"
          class="mr-3"
        ></v-select>
        <v-switch
            v-model="comparePrevious"
            label="Σύγκριση με προηγούμενο έτος"
            class="ml-3"
            dense
        ></v-switch>
        <v-spacer/>
        <v-chip>{{ $tocurr(totalPurchases) }}</v-chip>
      </v-row>
        <div class="mt-4">
          <apexchart
            v-if="chartOptions && chartSeries"
            type="bar"
            height="450"
            :options="chartOptions"
            :series="chartSeries"
          />
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts
  },
  computed: {
    totalPurchases() {
      // If comparing, sum selected year only for display
      const purchases = Array.isArray(this.purchases) ? this.purchases : Object.values(this.purchases);
      return purchases.reduce((a, b) => a + (b.Balance || b || 0), 0);
    },
    months() {
      return [
        'Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαι', 'Ιουν',
        'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'
      ]
    },
    monthlyPurchasesData() {
      if (!this.purchases || typeof this.purchases !== 'object') return [];
      let data = [];
      for (let i = 1; i <= 12; i++) {
        data.push(this.purchases[i] || 0);
      }
      return data;
    },
    previousYearMonthlyData() {
      if (
        !this.previousYearPurchases ||
        typeof this.previousYearPurchases !== 'object'
      )
        return [];
      let data = [];
      for (let i = 1; i <= 12; i++) {
        data.push(this.previousYearPurchases[i] || 0);
      }
      return data;
    },
    averagePurchases() {
      const arr = this.monthlyPurchasesData;
      if (!arr.length) return 0;
      return arr.reduce((acc, val) => acc + val, 0) / arr.length;
    },
    chartOptions() {
      return {
        chart: {
          id: 'purchases-bar'
        },
        xaxis: {
          categories: this.months
        },
        title: {
          text: 'Αγορές ανά μήνα',
          align: 'center'
        },
        yaxis: {
          title: { text: 'Ποσό Αγορών' }
        },
        tooltip: {
          y: { formatter: val => `${val.toLocaleString()} €` }
        },
        annotations: this.comparePrevious
          ? {} // Don't show "average" line if comparing years
          : {
              yaxis: [
                {
                  y: this.averagePurchases,
                  borderColor: '#FF5252',
                  label: {
                    borderColor: '#FF5252',
                    style: { color: '#fff', background: '#FF5252' },
                    text: `Μέσος όρος: ${this.averagePurchases.toLocaleString(undefined, { maximumFractionDigits: 2 })} €`
                  }
                }
              ]
            }
      }
    },
    chartSeries() {
      if (this.comparePrevious) {
        return [
          {
            name: `${this.year}`,
            data: this.monthlyPurchasesData
          },
          {
            name: `${this.year - 1}`,
            data: this.previousYearMonthlyData
          }
        ];
      }
      // Single line: just this year
      return [
        {
          name: 'Αγορές',
          data: this.monthlyPurchasesData
        }
      ];
    }
  },
  data() {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear; y >= currentYear - 5; y--) {
      years.push(y);
    }
    return {
      purchases: {}, // Changed: Hold data per year as an object, not array
      previousYearPurchases: {},
      comparePrevious: false,
      loading: true,
      search: '',
      years,
      year: currentYear,
      supplier_id: this.$route.params.id,
    }
  },
  async created() {
    await this.fetchPurchases();
  },
  watch: {
    year() {
      this.fetchPurchases();
    },
    comparePrevious() {
      this.fetchPurchases();
    }
  },
  methods: {
    async fetchPurchases() {
      this.loading = true;
      try {
        // Always fetch for current year
        const responses = [];
        responses[0] = await this.$api.get('/suppliers/purchases-by-month', {
          params: { supplier_id: this.supplier_id, year: this.year }
        });
        this.purchases = responses[0].data['totals'] || {};
        // If user wants previous year: fetch also
        if (this.comparePrevious && this.year - 1 > 0) {
          responses[1] = await this.$api.get('/suppliers/purchases-by-month', {
            params: { supplier_id: this.supplier_id, year: this.year - 1 }
          });
          this.previousYearPurchases = responses[1].data['totals'] || {};
        } else {
          this.previousYearPurchases = {};
        }
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },
    showdialog(item) {
      this.diaitems = item.line_items;
      this.timdialog = true;
    },
    close() {
      this.timdialog = false;
    }
  }
}
</script>